"use client";

import { ArrowRight, FacebookIcon } from "lucide-react";
import { useState } from "react";
import Header from "./Header";
import Link from "next/link";
import { SheetContent, Sheet } from "@/components/ui/sheet";
import { Button } from "../ui/button";
import { NavigationMenu } from "@/components/ui/navigation-menu";
import Image from "next/image";

export default function Navbar() {
  const [isMegaMenuOpen, setIsMegaMenuOpen] = useState(false);

  return (
    <>
      <Sheet open={isMegaMenuOpen} onOpenChange={setIsMegaMenuOpen}>
        <SheetContent side="left">
          <div className="flex flex-col items-center gap-4 mb-6">
            <Image
              src="/localimages/sparkscommercialtirelogo.jpeg"
              alt="Sparks Logo"
              className="h-20 w-auto"
            />
            <div className="text-center px-4">
              <p className="text-sm text-gray-600">
                24/7 Commercial Tire Solutions since 1986
              </p>
            </div>
          </div>
          <hr className="mb-4" />
          <div className="grid gap-2 py-6">
            {/* <Link
              className="flex w-full items-center py-2 text-lg font-semibold"
              href="/"
            >
              Home
            </Link>
            <Link
              className="flex w-full items-center py-2 text-lg font-semibold"
              href="/consumer/about"
            >
              About
            </Link>
            <Link
              className="flex w-full items-center py-2 text-lg font-semibold"
              href="/consumer/services"
            >
              Services
            </Link>
            <Link
              className="flex w-full items-center py-2 text-lg font-semibold"
              href="/consumer/safety"
            >
              Safety
            </Link>
            <Link
              className="flex w-full items-center py-2 text-lg font-semibold"
              href="/consumer/contact"
            >
              Contact
            </Link> */}

            <hr />

            <div className="pt-5">
              <Link href={"/consumer/locations"} className="block w-full">
                <Button className="w-full py-3 text-base font-medium">
                  Our Locations
                </Button>
              </Link>
            </div>
          </div>

          <div className="flex justify-center mt-auto">
            <a
              href="https://www.facebook.com/sparkstire/?_rdr"
              className="text-blue-600 hover:text-gray-900 transition-colors duration-200"
              target="_blank"
              rel="noopener noreferrer"
            >
              <FacebookIcon className="h-6 w-6" />
            </a>
          </div>
        </SheetContent>
      </Sheet>

      <Header />

      <nav>
        <div className="max-w-screen-xl border-b border-gray-200 flex flex-wrap items-center justify-between mx-auto p-4">
          <Link
            href="/"
            className="flex items-center space-x-3 rtl:space-x-reverse"
          >
            <Image
              src="/localimages/sparkscommercialtirelogo.jpeg"
              className="h-28"
              alt="Sparks Logo"
              width={200}
              height={100}
            />
          </Link>

          <div className="flex md:order-2 space-x-3 md:space-x-0 rtl:space-x-reverse">
            <div className="hidden sm:block">
              <Link href={"/consumer/locations"} className="block">
                <button
                  type="button"
                  className="text-white bg-black focus:ring-4 focus:outline-none font-medium rounded-lg text-sm px-4 py-2 text-center flex items-center"
                >
                  Our Locations <ArrowRight size={15} className="ml-1" />
                </button>
              </Link>
            </div>

            <Button
              data-collapse-toggle="navbar-cta"
              type="button"
              className="inline-flex items-center bg-transparent p-2 w-10 h-10 justify-center text-sm text-black rounded-lg md:hidden hover:bg-gray-100 focus:outline-none focus:ring-2 focus:ring-gray-200"
              aria-controls="navbar-cta"
              aria-expanded="false"
              variant="outline"
              onClick={() => setIsMegaMenuOpen(true)}
            >
              <svg
                className="w-5 h-5"
                aria-hidden="true"
                xmlns="http://www.w3.org/2000/svg"
                fill="none"
                viewBox="0 0 17 14"
              >
                <path
                  stroke="currentColor"
                  strokeLinecap="round"
                  strokeLinejoin="round"
                  strokeWidth="2"
                  d="M1 1h15M1 7h15M1 13h15"
                />
              </svg>
            </Button>
          </div>
          <div
            className="items-center justify-between hidden w-full md:flex md:w-auto md:order-1"
            id="navbar-cta"
          >
            <NavigationMenu>
              {/* <NavigationMenuList>
                <NavigationMenuItem>
                  <Link href="/" legacyBehavior passHref>
                    <NavigationMenuLink className="group inline-flex h-10 w-max items-center justify-center rounded-md bg-white px-4 py-2 text-sm font-medium transition-colors hover:bg-gray-100 hover:text-gray-900 focus:bg-gray-100 focus:text-gray-900 focus:outline-none disabled:pointer-events-none disabled:opacity-50 data-[active]:bg-gray-100/50 data-[state=open]:bg-gray-100/50">
                      Home
                    </NavigationMenuLink>
                  </Link>
                </NavigationMenuItem>

                <NavigationMenuItem>
                  <NavigationMenuTrigger>About</NavigationMenuTrigger>
                  <NavigationMenuContent>
                    <div className="grid gap-3 p-6 w-[400px]">
                      <Link href="/consumer/about" legacyBehavior passHref>
                        <NavigationMenuLink className="block select-none space-y-1 rounded-md p-3 leading-none no-underline outline-none transition-colors hover:bg-gray-100 focus:bg-gray-100">
                          <div className="text-sm font-medium leading-none">
                            About Us
                          </div>
                          <p className="line-clamp-2 text-sm leading-snug text-gray-500">
                            Learn more about our company history and values
                          </p>
                        </NavigationMenuLink>
                      </Link>
                    </div>
                  </NavigationMenuContent>
                </NavigationMenuItem>

                <NavigationMenuItem>
                  <NavigationMenuTrigger>Services</NavigationMenuTrigger>
                  <NavigationMenuContent>
                    <div className="grid gap-3 p-6 w-[400px]">
                      <Link href="/consumer/services" legacyBehavior passHref>
                        <NavigationMenuLink className="block select-none space-y-1 rounded-md p-3 leading-none no-underline outline-none transition-colors hover:bg-gray-100 focus:bg-gray-100">
                          <div className="text-sm font-medium leading-none">
                            Our Services
                          </div>
                          <p className="line-clamp-2 text-sm leading-snug text-gray-500">
                            Explore our comprehensive tire services and
                            solutions
                          </p>
                        </NavigationMenuLink>
                      </Link>
                    </div>
                  </NavigationMenuContent>
                </NavigationMenuItem>

                <NavigationMenuItem>
                  <NavigationMenuTrigger>Safety</NavigationMenuTrigger>
                  <NavigationMenuContent>
                    <div className="grid gap-3 p-6 w-[400px]">
                      <Link href="/consumer/safety" legacyBehavior passHref>
                        <NavigationMenuLink className="block select-none space-y-1 rounded-md p-3 leading-none no-underline outline-none transition-colors hover:bg-gray-100 focus:bg-gray-100">
                          <div className="text-sm font-medium leading-none">
                            Safety First
                          </div>
                          <p className="line-clamp-2 text-sm leading-snug text-gray-500">
                            Learn about our commitment to safety and best
                            practices
                          </p>
                        </NavigationMenuLink>
                      </Link>
                    </div>
                  </NavigationMenuContent>
                </NavigationMenuItem>

                <NavigationMenuItem>
                  <Link href="/consumer/contact" legacyBehavior passHref>
                    <NavigationMenuLink className="group inline-flex h-10 w-max items-center justify-center rounded-md bg-white px-4 py-2 text-sm font-medium transition-colors hover:bg-gray-100 hover:text-gray-900 focus:bg-gray-100 focus:text-gray-900 focus:outline-none disabled:pointer-events-none disabled:opacity-50 data-[active]:bg-gray-100/50 data-[state=open]:bg-gray-100/50">
                      Contact
                    </NavigationMenuLink>
                  </Link>
                </NavigationMenuItem>
              </NavigationMenuList> */}
            </NavigationMenu>
          </div>
        </div>
      </nav>
    </>
  );
}
